import React, { forwardRef } from "react";

// 1. Extend standard input attributes so it accepts name, onChange, onBlur, etc.
interface ToggleSwitchProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  type?: "checkbox" | "radio"; // Allow switching between the two
}

// 2. Use forwardRef to catch the 'ref' that RHF needs to focus/manage the input
const ToggleSwitch = forwardRef<HTMLInputElement, ToggleSwitchProps>(
  ({ label, id, type = "checkbox", ...props }, ref) => {
    
    // Fallback ID to ensure label always clicks the input
    const inputId = id || props.name || `switch-${Math.random()}`;

    return (
      <div className="flipswitch">
        <div className="switch-container">
          <input
            {...props}       // This spreads name, onChange, and onBlur from RHF
            ref={ref}        // This attaches the RHF internal reference
            type={type}
            id={inputId}
            className="flipswitch-cb"
          />
          <label className="flipswitch-label" htmlFor={inputId}>
            <div className="flipswitch-inner" />
            <div className="flipswitch-switch" />
          </label>
        </div>
        <span className="label">{label}</span>
      </div>
    );
  }
);

ToggleSwitch.displayName = "ToggleSwitch";

export default ToggleSwitch;